import(/* webpackMode: "eager" */ "/var/www/luaitools.com/app/global-error.tsx");
